import firebase from 'firebase'
import firestore from 'firebase/firestore'

var config = {
    apiKey: "AIzaSyC0RBeHN9RNSxVKJwjKyIpT6h31MLulRPY",
    authDomain: "appricot-chat.firebaseapp.com",
    databaseURL: "https://appricot-chat.firebaseio.com",
    projectId: "appricot-chat",
    storageBucket: "appricot-chat.appspot.com",
    messagingSenderId: "812352079431"
  };
 
  const firebaseApp = firebase.initializeApp(config);
 firebaseApp.firestore().settings({timestampsInSnapshots: true});
 export default firebaseApp.firestore()
 
 


// WEBPACK FOOTER //
// ./src/firebase/init.js